import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgGoalPeace = (props) => /* @__PURE__ */ _jsx("svg", {
	preserveAspectRatio: "none",
	width: "100%",
	height: "100%",
	overflow: "visible",
	style: { display: "block" },
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		id: "yoga-01 1",
		children: [
			/* @__PURE__ */ _jsx("path", {
				id: "Vector",
				d: "M12.1231 21.3333C11.7106 22.2425 10.7601 22.648 9.91849 23.0883L5.05683 25.6311C3.1046 26.6521 4.07932 29.3333 6.17313 29.3333C10.8294 29.3333 14.5115 27.0752 18.7205 25.3333C19.78 24.8948 20.2935 24.9887 21.3333 25.4549",
				stroke: "var(--stroke-0, #9565FD)",
				strokeWidth: 2,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Vector_2",
				d: "M12 25.4549C13.0399 24.9887 13.5533 24.8948 14.6128 25.3333C18.8219 27.0752 22.504 29.3333 27.1603 29.3333C29.254 29.3333 30.2287 26.6521 28.2765 25.6311L23.4148 23.0883C22.5732 22.648 21.6228 22.2425 21.2103 21.3333",
				stroke: "var(--stroke-0, #9565FD)",
				strokeWidth: 2,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Vector_3",
				d: "M13.3333 5.33333C13.3333 6.80609 14.5272 8 16 8C17.4728 8 18.6667 6.80609 18.6667 5.33333C18.6667 3.86057 17.4728 2.66667 16 2.66667C14.5272 2.66667 13.3333 3.86057 13.3333 5.33333Z",
				stroke: "var(--stroke-0, #9565FD)",
				strokeWidth: 2
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Vector_4",
				d: "M16 10.6667C11.5817 10.6667 8 14.2484 8 18.6667C12.4183 18.6667 16 15.0849 16 10.6667Z",
				stroke: "var(--stroke-0, #9565FD)",
				strokeWidth: 2,
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Vector_5",
				d: "M16 10.6667C20.4183 10.6667 24 14.2484 24 18.6667C19.5817 18.6667 16 15.0849 16 10.6667Z",
				stroke: "var(--stroke-0, #9565FD)",
				strokeWidth: 2,
				strokeLinejoin: "round"
			})
		]
	})
});
export default SvgGoalPeace;
